import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  AudioOutlined,
  DeleteOutlined,
  LoadingOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  Form,
  Input,
  Radio,
  Row,
  Space,
  Tooltip,
  Upload,
} from "antd";
import {
  DISPLAY_CALLER_ID_TYPE,
  // DURATION_OPTIONS,
  OUTGOING_MESSAGE_TYPE,
  PATTERNS,
  UPLOAD_FILE_TYPE,
  VOICE_SETTING_OPTIONS,
} from "constants/appConstant";
import { useFormik } from "formik";
import parsePhoneNumber from "libphonenumber-js";
import { getServiceNumber } from "stores/slices/numbers";
import { doUploadAvatar } from "stores/slices/upload";
import { createDurationOptions } from "utils";
import * as Yup from "yup";

import AudioRecord from "components/audio/audioRecord";
import AppSelect from "components/inputs/select";

const VoiceSettingForm = forwardRef(function VoiceSettingForm(props, ref) {
  const { voiceSettingDetail, onSubmit, disabled } = props;
  const { t } = useTranslation();
  const serviceNumber = useSelector(getServiceNumber);
  const [numberPhoneChange, setChangeValueNumber] = useState();
  const [optionType, setOptionType] = useState("");
  const [currentOptionType, setCurrentOptionType] = useState(
    VOICE_SETTING_OPTIONS.DISABLE
  );

  const durationOptions = createDurationOptions(20, 300, 10);

  const displayCallerOptions = [
    {
      value: DISPLAY_CALLER_ID_TYPE.CALLER_NUMBER,
      label: t("numbers.disCallerNumber"),
    },
    {
      value: DISPLAY_CALLER_ID_TYPE.SERVICE_NUMBER,
      label: t("numbers.disServiceNumber"),
    },
  ];

  const aiVoiceOptions = [
    {
      value: "Olivia",
      label: "Olivia",
    },
    {
      value: "Russell",
      label: "Russell",
    },
  ];

  const numberSecondsOptions = [
    {
      value: 10,
      label: `10 seconds`,
    },
    {
      value: 15,
      label: `15 seconds`,
    },
    {
      value: 20,
      label: `20 seconds`,
    },
    {
      value: 25,
      label: `25 seconds`,
    },
    {
      value: 30,
      label: `30 seconds`,
    },
  ];

  const onChangeVoiceMailOptions = e => {
    setCurrentOptionType(e?.target?.value);
    setOptionType(e?.target?.value);
    setFieldValue("optionType", e?.target?.value);
  };

  const onSubmitForm = values => {
    let data = { option: values?.optionType };
    if (values?.optionType === VOICE_SETTING_OPTIONS.FORWARD_TO_PSTN_NUMBER) {
      data = {
        ...data,
        forwardPstnSetting: {
          forwardNumber: values?.forwardNumber ? values?.forwardNumber : "",
          outgoingMessageType: values?.outgoingMessageType
            ? values?.outgoingMessageType
            : OUTGOING_MESSAGE_TYPE.TEXT_TO_SPEECH,
          textToSpeech: values?.textToSpeech ? values?.textToSpeech : "",
          aiVoice: values?.aiVoice ? values?.aiVoice : aiVoiceOptions[0]?.value,
          displayCallerIdType: values?.displayCallerIdType
            ? values?.displayCallerIdType
            : DISPLAY_CALLER_ID_TYPE.SERVICE_NUMBER,
          maxTimeWaitForAnswer: values?.maximumAnswer,
          maxTimeCallDuration: values?.maximumCallDuration,
          uploadFilePath: values?.pstnUploadFilePath
            ? values?.pstnUploadFilePath
            : "",
          recordFilePath: values?.pstnRecordFilePath
            ? values?.pstnRecordFilePath
            : "",
        },
      };
    }

    if (
      values?.optionType ===
      VOICE_SETTING_OPTIONS.RESPONSE_WITH_MESSAGE_AND_RECORD_VOICEMAIL
    ) {
      data = {
        ...data,
        responseMessageAndRecordVoicemailSetting: {
          outgoingMessageType: values?.outgoingMessageType
            ? values?.outgoingMessageType
            : OUTGOING_MESSAGE_TYPE.TEXT_TO_SPEECH,
          textToSpeech: values?.textToSpeech ? values?.textToSpeech : "",
          aiVoice: values?.aiVoice ? values?.aiVoice : aiVoiceOptions[0]?.value,
          maxTimeCallDuration: values?.maximumVoiceMailDuration,
          uploadFilePath: values?.voiceMailUploadFilePath
            ? values?.voiceMailUploadFilePath
            : "",
          recordFilePath: values?.voiceMailRecordFilePath
            ? values?.voiceMailRecordFilePath
            : "",
        },
      };
    }

    onSubmit &&
      onSubmit({
        ...data,
      });
  };
  const validationSchema = Yup.object().shape({
    forwardNumber: Yup.string()
      .trim()
      .required("validate.required")
      // .test("forwardNumber", "validate.phoneNumber.invalid", value => {
      //   let phoneNumber = value;
      //   if (phoneNumber?.length > 0) {
      //     if (
      //       PATTERNS.PHONE_NUMBER_LENGTH.test(value) &&
      //       PATTERNS.ZERO_ONLY.test(value)
      //     ) {
      //       const validPhoneNumber = parsePhoneNumber(phoneNumber, "AU");
      //       if (validPhoneNumber && validPhoneNumber.isPossible()) {
      //         if (validPhoneNumber.country && validPhoneNumber.isValid()) {
      //           const newValue = validPhoneNumber.formatInternational();
      //           setChangeValueNumber(
      //             newValue.toString().replaceAll(" ", "").replaceAll("+", "")
      //           );
      //           return true;
      //         }
      //       } else {
      //         phoneNumber = value.includes("+") ? value : `+${phoneNumber}`;
      //         const validContactNumber = parsePhoneNumber(phoneNumber, "AU");
      //         if (validContactNumber && validContactNumber.isPossible()) {
      //           if (
      //             validContactNumber.country &&
      //             validContactNumber.isValid()
      //           ) {
      //             const newValue = validContactNumber.formatInternational();
      //             setChangeValueNumber(
      //               newValue.toString().replaceAll(" ", "").replaceAll("+", "")
      //             );
      //             return true;
      //           } else {
      //             setChangeValueNumber(value);
      //             return false;
      //           }
      //         } else {
      //           const validPhoneNumber2 = parsePhoneNumber(value, "AU");
      //           if (validPhoneNumber2 && validPhoneNumber2.isPossible()) {
      //             if (
      //               validPhoneNumber2.country &&
      //               validPhoneNumber2.isValid()
      //             ) {
      //               const newValue = validPhoneNumber2.formatInternational();
      //               setChangeValueNumber(
      //                 newValue
      //                   .toString()
      //                   .replaceAll(" ", "")
      //                   .replaceAll("+", "")
      //               );
      //               return true;
      //             } else {
      //               setChangeValueNumber(value);
      //               return false;
      //             }
      //           } else {
      //             const validContactNumber2 = parsePhoneNumber(
      //               phoneNumber,
      //               "AU"
      //             );
      //             if (validContactNumber2 && validContactNumber2.isPossible()) {
      //               if (
      //                 validContactNumber2.country &&
      //                 validContactNumber2.isValid()
      //               ) {
      //                 const newValue =
      //                   validContactNumber2.formatInternational();
      //                 setChangeValueNumber(
      //                   newValue
      //                     .toString()
      //                     .replaceAll(" ", "")
      //                     .replaceAll("+", "")
      //                 );
      //                 return true;
      //               } else {
      //                 setChangeValueNumber(value);
      //                 return false;
      //               }
      //             }
      //           }
      //         }
      //       }
      //     } else {
      //       setChangeValueNumber(value);
      //       return false;
      //     }
      //   } else {
      //     setChangeValueNumber(value);
      //     return true;
      //   }
      // })
      .test("forwardNumber", "validate.phoneNumber.invalid", value => {
        let phoneNumber = value;
        if (
          PATTERNS.PHONE_NUMBER_LENGTH.test(value) &&
          PATTERNS.ZERO_ONLY.test(value)
        ) {
          const validPhoneNumber = parsePhoneNumber(phoneNumber);
          if (validPhoneNumber && validPhoneNumber.isPossible()) {
            if (validPhoneNumber.country && validPhoneNumber.isValid()) {
              const newValue = validPhoneNumber.formatInternational();
              setChangeValueNumber(
                newValue.toString().replaceAll(" ", "").replaceAll("+", "")
              );
              return true;
            }
          } else {
            phoneNumber = value.includes("+") ? value : `+${phoneNumber}`;
            const validContactNumber = parsePhoneNumber(phoneNumber);

            if (validContactNumber && validContactNumber.isPossible()) {
              if (validContactNumber.country && validContactNumber.isValid()) {
                const newValue = validContactNumber.formatInternational();
                setChangeValueNumber(
                  newValue.toString().replaceAll(" ", "").replaceAll("+", "")
                );
                return true;
              } else {
                setChangeValueNumber(value);
                return false;
              }
            } else {
              const validPhoneNumber2 = parsePhoneNumber(value, "AU");
              if (validPhoneNumber2 && validPhoneNumber2.isPossible()) {
                if (validPhoneNumber2.country && validPhoneNumber2.isValid()) {
                  const newValue = validPhoneNumber2.formatInternational();
                  setChangeValueNumber(
                    newValue.toString().replaceAll(" ", "").replaceAll("+", "")
                  );
                  return true;
                } else {
                  setChangeValueNumber(value);
                  return false;
                }
              } else {
                const validContactNumber2 = parsePhoneNumber(phoneNumber, "AU");
                if (validContactNumber2 && validContactNumber2.isPossible()) {
                  if (
                    validContactNumber2.country &&
                    validContactNumber2.isValid()
                  ) {
                    const newValue = validContactNumber2.formatInternational();
                    setChangeValueNumber(
                      newValue
                        .toString()
                        .replaceAll(" ", "")
                        .replaceAll("+", "")
                    );
                    return true;
                  } else {
                    setChangeValueNumber(value);
                    return false;
                  }
                }
              }
            }
          }
        } else {
          setChangeValueNumber(value);
          return false;
        }
      })
      .test("forwardNumber", "validate.notSameServiceNumber", value => {
        return value !== serviceNumber;
      }),
  });

  const voiceSettingForm = useFormik({
    initialValues: {
      forwardNumber: "",
      textToSpeech: "",
      aiVoice: aiVoiceOptions[0]?.value,
      outgoingMessageType: OUTGOING_MESSAGE_TYPE.TEXT_TO_SPEECH,
      optionType: "",
      displayCallerIdType: DISPLAY_CALLER_ID_TYPE.SERVICE_NUMBER,
      maximumAnswer: numberSecondsOptions[0]?.value,
      maximumCallDuration: durationOptions[4]?.value,
      maximumVoiceMailDuration: durationOptions[4]?.value,
      pstnUploadFilePath: "",
      pstnRecordFilePath: "",
      voiceMailUploadFilePath: "",
      voiceMailRecordFilePath: "",
    },
    validationSchema:
      currentOptionType === VOICE_SETTING_OPTIONS.FORWARD_TO_PSTN_NUMBER
        ? validationSchema
        : null,
    onSubmit: onSubmitForm,
  });

  const {
    values,
    handleChange,
    handleSubmit,
    setFieldValue,
    setValues,
    errors,
    touched,
    // handleBlur,
    handleReset,
  } = voiceSettingForm;

  useImperativeHandle(ref, () => ({
    submitForm: () => {
      handleSubmit();
    },
    resetForm: () => {
      handleReset();
    },
    formErrors: errors,
    formTouch: touched,
  }));

  useEffect(() => {
    // Handle check valid number phone
    if (numberPhoneChange?.length > 0) {
      setFieldValue("forwardNumber", numberPhoneChange);
      setChangeValueNumber("");
    }
  }, [numberPhoneChange]);

  useEffect(() => {
    if (voiceSettingDetail) {
      // Check option type change set again value form
      const option = optionType || voiceSettingDetail?.option;

      setCurrentOptionType(option);

      if (option === VOICE_SETTING_OPTIONS.DISABLE) {
        setFieldValue("optionType", option);
      }

      if (option === VOICE_SETTING_OPTIONS.FORWARD_TO_PSTN_NUMBER) {
        const forwardPstnSetting = voiceSettingDetail?.forwardPstnSetting;
        setValues({
          optionType: option,
          forwardNumber: forwardPstnSetting?.forwardNumber
            ? forwardPstnSetting?.forwardNumber
            : "",
          textToSpeech: forwardPstnSetting?.textToSpeech
            ? forwardPstnSetting?.textToSpeech
            : "We appreciate your call. Please stand bye.",
          aiVoice: forwardPstnSetting?.aiVoice
            ? forwardPstnSetting?.aiVoice
            : aiVoiceOptions[0]?.value,
          outgoingMessageType: forwardPstnSetting?.outgoingMessageType
            ? forwardPstnSetting?.outgoingMessageType
            : OUTGOING_MESSAGE_TYPE.TEXT_TO_SPEECH,
          displayCallerIdType: forwardPstnSetting?.displayCallerIdType
            ? forwardPstnSetting?.displayCallerIdType
            : DISPLAY_CALLER_ID_TYPE.SERVICE_NUMBER,
          maximumAnswer: forwardPstnSetting?.maxTimeWaitForAnswer
            ? forwardPstnSetting?.maxTimeWaitForAnswer
            : numberSecondsOptions[0]?.value,
          maximumCallDuration: forwardPstnSetting?.maxTimeCallDuration
            ? forwardPstnSetting?.maxTimeCallDuration
            : durationOptions[4]?.value,
          pstnUploadFilePath: forwardPstnSetting?.uploadFilePath,
          pstnRecordFilePath: forwardPstnSetting?.recordFilePath,
        });
      }

      if (
        option ===
        VOICE_SETTING_OPTIONS.RESPONSE_WITH_MESSAGE_AND_RECORD_VOICEMAIL
      ) {
        const responseMessageAndRecordVoicemailSetting =
          voiceSettingDetail?.responseMessageAndRecordVoicemailSetting;
        setValues({
          optionType: option,
          forwardNumber: responseMessageAndRecordVoicemailSetting?.forwardNumber
            ? responseMessageAndRecordVoicemailSetting?.forwardNumber
            : "",
          textToSpeech: responseMessageAndRecordVoicemailSetting?.textToSpeech
            ? responseMessageAndRecordVoicemailSetting?.textToSpeech
            : "We appreciate your call. Please leave a message after the beep.",
          aiVoice: responseMessageAndRecordVoicemailSetting?.aiVoice
            ? responseMessageAndRecordVoicemailSetting?.aiVoice
            : aiVoiceOptions[0]?.value,
          outgoingMessageType:
            responseMessageAndRecordVoicemailSetting?.outgoingMessageType
              ? responseMessageAndRecordVoicemailSetting?.outgoingMessageType
              : OUTGOING_MESSAGE_TYPE.TEXT_TO_SPEECH,
          maximumVoiceMailDuration:
            responseMessageAndRecordVoicemailSetting?.maxTimeCallDuration
              ? responseMessageAndRecordVoicemailSetting?.maxTimeCallDuration
              : durationOptions[4]?.value,
          voiceMailUploadFilePath:
            responseMessageAndRecordVoicemailSetting?.uploadFilePath,
          voiceMailRecordFilePath:
            responseMessageAndRecordVoicemailSetting?.recordFilePath,
        });
      }
    } else {
      setValues({
        forwardNumber: "",
        textToSpeech:
          currentOptionType === VOICE_SETTING_OPTIONS.FORWARD_TO_PSTN_NUMBER
            ? "We appreciate your call. Please stand bye."
            : "We appreciate your call. Please leave a message after the beep.",
        aiVoice: aiVoiceOptions[0]?.value,
        outgoingMessageType: OUTGOING_MESSAGE_TYPE.TEXT_TO_SPEECH,
        optionType: currentOptionType,
        displayCallerIdType: DISPLAY_CALLER_ID_TYPE.SERVICE_NUMBER,
        maximumAnswer: numberSecondsOptions[0]?.value,
        maximumCallDuration: durationOptions[4]?.value,
        maximumVoiceMailDuration: durationOptions[4]?.value,
        uploadFilePath: "",
        recordFilePath: "",
      });
    }
  }, [voiceSettingDetail, optionType]);

  return (
    <>
      <Form layout="vertical">
        <Radio.Group
          onChange={onChangeVoiceMailOptions}
          value={values?.optionType}
          style={{
            width: "100%",
          }}
          disabled={disabled}
        >
          <Space
            direction="vertical"
            style={{
              width: "100%",
            }}
          >
            <Radio value={VOICE_SETTING_OPTIONS.FORWARD_TO_PSTN_NUMBER}>
              {t("numbers.forwardPSTNNumber")}
            </Radio>
            {values?.optionType ===
              VOICE_SETTING_OPTIONS.FORWARD_TO_PSTN_NUMBER && (
              <div style={styles.childContainer}>
                <OutGoingMessage
                  type={VOICE_SETTING_OPTIONS.FORWARD_TO_PSTN_NUMBER}
                  values={values}
                  setFieldValue={setFieldValue}
                  aiVoiceOptions={aiVoiceOptions}
                  handleChange={handleChange}
                  disabled={disabled}
                />

                <Form.Item
                  label={t("numbers.displayCaller")}
                  style={styles.formItem}
                >
                  <AppSelect
                    name="displayCallerIdType"
                    defaultValue={displayCallerOptions[0]}
                    options={displayCallerOptions}
                    value={values.displayCallerIdType}
                    onChange={value => {
                      setFieldValue("displayCallerIdType", value);
                    }}
                    style={styles.container}
                    disabled={disabled}
                  />
                </Form.Item>
                <Form.Item
                  label={t("numbers.enterNumberForward")}
                  colon={false}
                  validateStatus={
                    errors?.forwardNumber && touched?.forwardNumber && "error"
                  }
                  help={
                    errors?.forwardNumber &&
                    touched?.forwardNumber &&
                    t(errors?.forwardNumber)
                  }
                  style={styles.formItem}
                >
                  <Input
                    placeholder={t("numbers.enterNumberForward")}
                    id="forwardNumber"
                    name="forwardNumber"
                    value={values?.forwardNumber}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Item>

                <Form.Item
                  label={t("numbers.maximumAnswer")}
                  style={styles.formItem}
                >
                  <AppSelect
                    name="maximumAnswer"
                    defaultValue={numberSecondsOptions[0]?.value}
                    options={numberSecondsOptions}
                    value={values?.maximumAnswer}
                    onChange={value => {
                      setFieldValue("maximumAnswer", value);
                    }}
                    disabled={disabled}
                  />
                </Form.Item>
                <Form.Item
                  label={t("numbers.maximumCallDuration")}
                  style={styles.formItem}
                >
                  <AppSelect
                    name="maximumCallDuration"
                    defaultValue={durationOptions[4]}
                    options={durationOptions}
                    value={values?.maximumCallDuration}
                    onChange={value => {
                      setFieldValue("maximumCallDuration", value);
                    }}
                    disabled={disabled}
                    style={styles.container}
                  />
                </Form.Item>
              </div>
            )}

            <Radio
              value={
                VOICE_SETTING_OPTIONS.RESPONSE_WITH_MESSAGE_AND_RECORD_VOICEMAIL
              }
            >
              {t("numbers.respondMessageAndRecord")}
            </Radio>
            {values?.optionType ===
              VOICE_SETTING_OPTIONS.RESPONSE_WITH_MESSAGE_AND_RECORD_VOICEMAIL && (
              <div style={styles.childContainer}>
                <OutGoingMessage
                  type={
                    VOICE_SETTING_OPTIONS.RESPONSE_WITH_MESSAGE_AND_RECORD_VOICEMAIL
                  }
                  values={values}
                  setFieldValue={setFieldValue}
                  aiVoiceOptions={aiVoiceOptions}
                  handleChange={handleChange}
                  disabled={disabled}
                />
                <Form.Item
                  label={t("numbers.maximumVoiceMailDuration")}
                  style={styles.formItem}
                >
                  <AppSelect
                    name="maximumVoiceMailDuration"
                    defaultValue={durationOptions[4]}
                    options={durationOptions}
                    value={values.maximumVoiceMailDuration}
                    onChange={value => {
                      setFieldValue("maximumVoiceMailDuration", value);
                    }}
                    style={styles.container}
                    disabled={disabled}
                  />
                </Form.Item>
              </div>
            )}
            <Radio value={VOICE_SETTING_OPTIONS.DISABLE}>
              {t("numbers.disable")}
            </Radio>
          </Space>
        </Radio.Group>
      </Form>
    </>
  );
});

const OutGoingMessage = props => {
  const {
    type,
    values,
    setFieldValue,
    aiVoiceOptions,
    handleChange,
    disabled,
  } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const audioRecordRef = useRef(null);
  const [isStartAudioRecording, setIsStartAudioRecording] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [fileUpload, setFileUpload] = useState(null);

  const [outGoingMessOptions, setOutGoingMessOptions] = useState([]);
  const handleDeleteFilePath = (field, value) => {
    setFieldValue(field, value);
  };

  const generateOutGoingMessOptions = voiceOptionType => {
    let options = [
      {
        label: t("numbers.uploadRecording"),
        value: OUTGOING_MESSAGE_TYPE.UPLOAD,
      },
      {
        label: t("numbers.recordMessage"),
        value: OUTGOING_MESSAGE_TYPE.RECORD,
      },
      {
        label: t("numbers.textToSpeech"),
        value: OUTGOING_MESSAGE_TYPE.TEXT_TO_SPEECH,
      },
    ];
    if (voiceOptionType === VOICE_SETTING_OPTIONS.FORWARD_TO_PSTN_NUMBER) {
      options = [
        {
          label: t("numbers.noOutgoingMessage"),
          value: OUTGOING_MESSAGE_TYPE.NONE,
        },
        ...options,
      ];
    }
    setOutGoingMessOptions(options);
  };

  useEffect(() => {
    if (values?.optionType) {
      generateOutGoingMessOptions(values?.optionType);
    }
  }, [values?.optionType]);

  useEffect(() => {
    // Handle upload audio file from Audio component
    if (fileUpload && fileUpload.file) {
      handleUpload(fileUpload.file, OUTGOING_MESSAGE_TYPE.RECORD);
    }
  }, [fileUpload]);

  const onChangeOutGoingMessage = e => {
    setFieldValue("outgoingMessageType", e?.target?.value);
  };

  const handleStartRecording = () => {
    setIsStartAudioRecording(true);
  };

  const handleUpload = async (file, outgoingMessageType) => {
    setUploading(true);
    const request = {
      cannedAccessControlList: "PublicRead",
      uploadFileType: UPLOAD_FILE_TYPE.UPLOAD_VOICE,
      file: file,
    };
    const { payload } = await dispatch(doUploadAvatar(request));
    if (payload && payload.status === 200) {
      if (type === VOICE_SETTING_OPTIONS.FORWARD_TO_PSTN_NUMBER) {
        switch (outgoingMessageType) {
          case OUTGOING_MESSAGE_TYPE.UPLOAD:
            setFieldValue("pstnUploadFilePath", payload?.data);
            break;
          case OUTGOING_MESSAGE_TYPE.RECORD:
            setFieldValue("pstnRecordFilePath", payload?.data);
            break;
          default:
            break;
        }
      }

      if (
        type ===
        VOICE_SETTING_OPTIONS.RESPONSE_WITH_MESSAGE_AND_RECORD_VOICEMAIL
      ) {
        switch (outgoingMessageType) {
          case OUTGOING_MESSAGE_TYPE.UPLOAD:
            setFieldValue("voiceMailUploadFilePath", payload?.data);
            break;
          case OUTGOING_MESSAGE_TYPE.RECORD:
            setFieldValue("voiceMailRecordFilePath", payload?.data);
            break;
          default:
            break;
        }
      }

      setUploading(false);
      setIsStartAudioRecording(false);
    } else {
      setUploading(false);
      setIsStartAudioRecording(false);
    }
  };

  const handleBeforeUpload = file => {
    if (file) {
      const isAudio = file?.type?.startsWith("audio/");
      if (!isAudio) {
        // setAudioFile(null);
        toast.error("You can only upload audio file!");
      }
      return isAudio;
    }
  };

  const handleUploadVoice = info => {
    if (info && info.file) {
      handleUpload(info.file, OUTGOING_MESSAGE_TYPE.UPLOAD);
    }
  };

  return (
    <div>
      <div>
        <p style={styles.labelTitle}>{t("numbers.outgoingMessage")}</p>
        <Radio.Group
          onChange={onChangeOutGoingMessage}
          defaultValue={OUTGOING_MESSAGE_TYPE.TEXT_TO_SPEECH}
          value={values?.outgoingMessageType}
          disabled={disabled}
        >
          <Space direction="horizontal">
            {outGoingMessOptions?.map((option, index) => {
              return (
                <Radio key={index} value={option?.value}>
                  {option?.label}
                </Radio>
              );
            })}
          </Space>
        </Radio.Group>
      </div>

      {values?.outgoingMessageType === OUTGOING_MESSAGE_TYPE.TEXT_TO_SPEECH && (
        <Row>
          <Col span={24}>
            <Form.Item
              label={t("numbers.enterMessageText")}
              style={styles.formItem}
            >
              <Input.TextArea
                placeholder={t("numbers.enterMessageText")}
                name="textToSpeech"
                rows={3}
                value={values?.textToSpeech}
                onChange={handleChange}
                disabled={disabled}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label={t("numbers.AIVoice")} style={styles.formItem}>
              <AppSelect
                name="aiVoice"
                defaultValue={aiVoiceOptions[0]?.value}
                options={aiVoiceOptions}
                value={values.aiVoice}
                onChange={value => {
                  setFieldValue("aiVoice", value);
                }}
                disabled={disabled}
                style={styles.container}
              />
            </Form.Item>
          </Col>
        </Row>
      )}
      {values?.outgoingMessageType === OUTGOING_MESSAGE_TYPE.UPLOAD &&
        type === VOICE_SETTING_OPTIONS.FORWARD_TO_PSTN_NUMBER && (
          <>
            {!values?.pstnUploadFilePath ? (
              <div style={styles.uploadVoiceContainer}>
                <Upload
                  beforeUpload={handleBeforeUpload}
                  customRequest={handleUploadVoice}
                  showUploadList={false}
                  multiple={false}
                  accept={"audio/*"}
                >
                  <Button
                    icon={uploading ? <LoadingOutlined /> : <UploadOutlined />}
                    disabled={disabled || uploading}
                  >
                    {uploading
                      ? t("numbers.uploading")
                      : t("numbers.uploadRecording")}
                  </Button>
                </Upload>
              </div>
            ) : (
              <div style={styles.uploadVoiceText}>
                <audio src={values?.pstnUploadFilePath} controls />
                <div style={styles.deleteVoiceTextBtn}>
                  <Tooltip title={t("numbers.deleteVoiceMessage")}>
                    <Button
                      shape="circle"
                      type="text"
                      icon={<DeleteOutlined />}
                      onClick={() =>
                        handleDeleteFilePath("pstnUploadFilePath", "")
                      }
                      disabled={disabled || uploading}
                    />
                  </Tooltip>
                </div>
              </div>
            )}
          </>
        )}
      {values?.outgoingMessageType === OUTGOING_MESSAGE_TYPE.RECORD &&
        type === VOICE_SETTING_OPTIONS.FORWARD_TO_PSTN_NUMBER && (
          <>
            {!values?.pstnRecordFilePath ? (
              <div style={styles.uploadVoiceContainer}>
                {!isStartAudioRecording && (
                  <Button
                    icon={<AudioOutlined />}
                    disabled={disabled || uploading}
                    onClick={handleStartRecording}
                  >
                    {t("numbers.recordMessage")}
                  </Button>
                )}

                {isStartAudioRecording && (
                  <div style={styles.audioRecordContainer}>
                    <AudioRecord
                      isShowDiscardRecord={true}
                      ref={audioRecordRef}
                      isStartAudioRecording={isStartAudioRecording}
                      setIsStartAudioRecording={setIsStartAudioRecording}
                      setAudioFile={setFileUpload}
                    />
                    <Tooltip title={t("numbers.uploadVoiceMail")}>
                      <Button
                        type="text"
                        shape="circle"
                        onClick={() => {
                          audioRecordRef?.current?.handleRecordingComplete();
                        }}
                        icon={<UploadOutlined />}
                        style={{ marginLeft: 8 }}
                      />
                    </Tooltip>
                  </div>
                )}
              </div>
            ) : (
              <div style={styles.uploadVoiceText}>
                <audio src={values?.pstnRecordFilePath} controls />
                <div style={styles.deleteVoiceTextBtn}>
                  <Tooltip title={t("numbers.deleteVoiceMessage")}>
                    <Button
                      shape="circle"
                      type="text"
                      icon={<DeleteOutlined />}
                      onClick={() =>
                        handleDeleteFilePath("pstnRecordFilePath", "")
                      }
                      disabled={disabled || uploading}
                    />
                  </Tooltip>
                </div>
              </div>
            )}
          </>
        )}

      {values?.outgoingMessageType === OUTGOING_MESSAGE_TYPE.UPLOAD &&
        type ===
          VOICE_SETTING_OPTIONS.RESPONSE_WITH_MESSAGE_AND_RECORD_VOICEMAIL && (
          <>
            {!values?.voiceMailUploadFilePath ? (
              <div style={styles.uploadVoiceContainer}>
                <Upload
                  beforeUpload={handleBeforeUpload}
                  customRequest={handleUploadVoice}
                  showUploadList={false}
                  multiple={false}
                  accept={"audio/*"}
                >
                  <Button
                    icon={uploading ? <LoadingOutlined /> : <UploadOutlined />}
                    disabled={disabled || uploading}
                  >
                    {uploading
                      ? t("numbers.uploading")
                      : t("numbers.uploadRecording")}
                  </Button>
                </Upload>
              </div>
            ) : (
              <div style={styles.uploadVoiceText}>
                <audio src={values?.voiceMailUploadFilePath} controls />
                <div style={styles.deleteVoiceTextBtn}>
                  <Tooltip title={t("numbers.deleteVoiceMessage")}>
                    <Button
                      shape="circle"
                      type="text"
                      icon={<DeleteOutlined />}
                      onClick={() =>
                        handleDeleteFilePath("voiceMailUploadFilePath", "")
                      }
                      disabled={disabled || uploading}
                    />
                  </Tooltip>
                </div>
              </div>
            )}
          </>
        )}
      {values?.outgoingMessageType === OUTGOING_MESSAGE_TYPE.RECORD &&
        type ===
          VOICE_SETTING_OPTIONS.RESPONSE_WITH_MESSAGE_AND_RECORD_VOICEMAIL && (
          <>
            {!values?.voiceMailRecordFilePath ? (
              <div style={styles.uploadVoiceContainer}>
                {!isStartAudioRecording && (
                  <Button
                    icon={<AudioOutlined />}
                    disabled={disabled || uploading}
                    onClick={handleStartRecording}
                  >
                    {t("numbers.recordMessage")}
                  </Button>
                )}

                {isStartAudioRecording && (
                  <div style={styles.audioRecordContainer}>
                    <AudioRecord
                      isShowDiscardRecord={true}
                      ref={audioRecordRef}
                      isStartAudioRecording={isStartAudioRecording}
                      setIsStartAudioRecording={setIsStartAudioRecording}
                      setAudioFile={setFileUpload}
                    />
                    <Tooltip title={t("numbers.uploadVoiceMail")}>
                      <Button
                        type="text"
                        shape="circle"
                        onClick={() => {
                          audioRecordRef?.current?.handleRecordingComplete();
                        }}
                        icon={<UploadOutlined />}
                        style={{ marginLeft: 8 }}
                      />
                    </Tooltip>
                  </div>
                )}
              </div>
            ) : (
              <div style={styles.uploadVoiceText}>
                <audio src={values?.voiceMailRecordFilePath} controls />
                <div style={styles.deleteVoiceTextBtn}>
                  <Tooltip title={t("numbers.deleteVoiceMessage")}>
                    <Button
                      shape="circle"
                      type="text"
                      icon={<DeleteOutlined />}
                      onClick={() =>
                        handleDeleteFilePath("voiceMailRecordFilePath", "")
                      }
                      disabled={disabled || uploading}
                    />
                  </Tooltip>
                </div>
              </div>
            )}
          </>
        )}
    </div>
  );
};

export default VoiceSettingForm;

const styles = {
  container: {
    width: "100%",
  },
  childContainer: {
    paddingLeft: "20px",
    paddingRight: "10px",
  },
  labelTitle: {
    fontSize: "14px",
    marginBottom: "8px",
  },
  formItem: {
    marginBottom: 8,
  },

  uploadVoiceContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "16px",
  },
  audioRecordContainer: {
    marginTop: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  uploadVoiceText: {
    marginTop: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  deleteVoiceTextBtn: {
    marginLeft: "8px",
  },
};
